module.exports = __webpack_public_path__ + "static/media/social-stackoverflow.97eaffae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-stackoverflow.svg
// module id = 142
// module chunks = 0